import React, { useState, useCallback, useEffect } from "react";
import useStyles from "./style";
import { Button, Grid, Typography , Menu , MenuItem ,TextField } from "@mui/material";
import {EditOutlined ,DeleteOutline , History} from "@mui/icons-material";
import { DataGrid  } from "@mui/x-data-grid";
import * as XLSX from "xlsx";
import Papa from "papaparse";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { GridToolbarQuickFilter } from '@mui/x-data-grid';
import { Box } from '@mui/material';
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import _ from "lodash";

//Services
import corporategrpApi from "Services/CorporateEmployee";

//Modals
import CorporateAddemployeeModal from "Pages/Modals/Corporateemployee/Create";
import CorporateUpdateModal from "Pages/Modals/Corporateemployee/Update";
import CorpempDeleteDialog from "Pages/Modals/Corporateemployee/Delete";

const Corporategroup = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [row, setRow] = useState([]);
  const [bulkrow, setbulkrow] = useState([]);
  const [currentRowData, setCurrentRowData] = useState({}); // State to hold the current row data
  const [customerId, setCustomerId] = useState("");

  //Pagination

  const [page, setPage] = useState(1); // Initial page number
  const [pageSize, setPageSize] = useState(5); // Initial page size
  const [totalPages, setTotalPages] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openaction = Boolean(anchorEl);
  const handleClick = (event, rowData) => {
    setCurrentRowData(rowData);
    setAnchorEl(event.currentTarget);
  };
  const handleCloseaction = () => {
    setAnchorEl(null);
  };

  //Modals

  const [addemployeeModal, setAddemployeeModal] = useState(false);
  
  const handleOpenAddemployeeModal = () => {
    setAddemployeeModal(true);
  };

  const handleCloseAddemployeeModal = () => {
    setAddemployeeModal(false);
    getCorporateemps();
  };

  const [updateEmpModel, setUpdateEmpModal] = useState(false);

  const handleOpenUpdateEmpModal = (row) => {
    setCustomerId(row?._id);
    setUpdateEmpModal(true);
    setAnchorEl(null);
  };

  const handleCloseUpdateEmpModal = () => {
    setUpdateEmpModal(false);
    getCorporateemps();
  };

  const [deleteEmpModal, setdeleteempModal] = useState(false);
  const [emp_name , setempname] = useState("");

  const handleOpenDeleteEmpModal = (row) => {
    setCustomerId(row?._id);
    setempname(row?.employeeName);
    setdeleteempModal(true);
    setAnchorEl(null);
  };

  const handleCloseDeleteEmpModal = (row) => {
    setdeleteempModal(false);
    getCorporateemps();
  };


  // Get Passenger list api
  const getCorporateemps = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
       // console.log('datas ---> ',res?.data?.data?.data);
        setTotalPages(res?.data?.data?.totalRecords || 1);
        setRow(res?.data?.data?.data);
      } else {
        setRow([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("error fetch service area", err);
    };
    corporategrpApi
      .getCorporateEmpList({ page, limit: pageSize, search: searchText})
      .then(onSuccess, onFailure);
  }, [page, pageSize ,searchText]);

  useEffect(() => {
    getCorporateemps();
  }, [getCorporateemps]);

  const handlePageChange = (newPage) => {
    let theNewPage = parseInt(newPage) + 1;
    if (theNewPage >= 1) {
      setPage(theNewPage);
    }
  };

  const handleCopy = () => {
      // Define column widths
      const columnWidths = [5, 15, 25 , 15, 25, 15 ]; // Adjust widths as needed

      // Helper function to pad text to the desired width
      const padText = (text, width) => {
        return (text ?? "").toString().padEnd(width, " ");
      };
      // Create table header
      const header = [
        padText("S.NO", columnWidths[0]),
        padText("Group Name", columnWidths[1]),
        padText("Employee name", columnWidths[2]),
        padText("Employee Email", columnWidths[3]),
        padText("Employee code", columnWidths[4]),
        padText("Employee Mobile", columnWidths[5])

      ].join("");
    
      // Create table rows
      const rows = dataRows
        .map((row) =>
          [
            padText(row.sno, columnWidths[0]),
            padText(row.corporateGroupName, columnWidths[1]),
            padText(row.employeeName, columnWidths[2]),
            padText(row.employeeEmail, columnWidths[3]),
            padText(row.employeeCode, columnWidths[4]),
            padText(row.employeeMobile, columnWidths[5])
          ].join("")
        )
        .join("\n");
    
      // Combine header and rows
      const formattedContent = [header, rows].join("\n");
    
      // Copy to clipboard
      navigator.clipboard.writeText(formattedContent).then(() => {
        alert("Table copied to clipboard!");
      });
  };

  const handleDownloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(formatteddatas);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Services");
    XLSX.writeFile(workbook, "Employees.xlsx");
  };

  const handleDownloadCSV = () => {
  const csv = Papa.unparse(formatteddatas);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "Employees.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  };

  const handleDownloadPDF = () => {
    const doc = new jsPDF();
    const tableData = dataRows.map((row) => [
      row.sno,
      row.corporateGroupName,
      row.employeeName,
      row.employeeEmail,
      row.employeeCode,
      row.employeeMobile,
    ]);
    doc.autoTable({
      head: [["S.NO","Group Name","Employee Name","Email","Employee Code","Mobile"]],
      body: tableData,
    });
    doc.save("EmployeeList.pdf");
  };

  const calculateSno = (pageIndex, pageSize, index) => {
    return (pageIndex - 1) * pageSize + index + 1;
  };

  const dataRows = _.map(row || [], (data, index) => ({
    sno: calculateSno(page, pageSize, index),
    corporateGroupName: data?.corporateGroupName,
    employeeName:data?.employeeName,
    employeeEmail:data?.employeeEmail,
    employeeCode:data?.employeeCode,
    employeeMobile:data?.employeeMobile,
    row: data,
  }));

  const formatteddatas = dataRows.map((row) => ({
    "S.NO": row.sno,
    "Group Name":row.corporateGroupName,
    "Employee name":row.employeeName,
    "Employee Email":row.employeeEmail,
    "Employee code":row.employeeCode,
    "Employee Mobile":row.employeeMobile,
  }));

  const columns = [
    {
      field: "sno",
      headerName: "S.No",
      flex:0.5,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <>
            <div className={classes.lightText}>
              <Typography variant="body2">{params?.row?.sno}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "employeeName",
      headerName: "Employee Name",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.employeeName}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "employeeEmail",
      headerName: "Email Id",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.employeeEmail}</Typography>
            </div>
          </>
        );
      },
    },        
    {
      field: "corporateGroupName",
      headerName: "Group Name",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.corporateGroupName}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "employeeCode",
      headerName: "Emp Code",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.employeeCode}</Typography>
            </div>
          </>
        );
      },
    },
    {
      field: "employeeMobile",
      headerName: "Mobile Number",
      flex:1,
      sortable: true,
      renderCell: (params) => {
        return (
          <>
            <div>
              <Typography variant="body2">{params?.row?.employeeMobile}</Typography>
            </div>
          </>
        );
      },
    },        
    {
      field: "actions",
      headerName: "Actions",
      flex:1,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        const rowData = params?.row?.row;
        return (
          <div className={classes.iconsWrapper}>
            {/* Action Button with Dropdown */}
            <Button
              id="basic-button"
              aria-controls={openaction ? "basic-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={openaction ? "true" : undefined}
              onClick={(e) => handleClick(e, rowData)}
            >
              Action
            </Button>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={openaction}
              onClose={handleCloseaction}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >     
              {/* Edit Option */}
              <MenuItem onClick={() => handleOpenUpdateEmpModal(currentRowData)}>
                <section className={classes.editIcon}>
                  <EditOutlined />
                  <Typography variant="subtitle2" gutterBottom className={classes.actiontypo}>
                    Edit
                  </Typography>
                </section>
              </MenuItem>
      
              {/* Delete Option */}
              <MenuItem onClick={() => handleOpenDeleteEmpModal(currentRowData)}>
                <section className={classes.deleteIcon}>
                  <DeleteOutline />
                  <Typography variant="subtitle2" gutterBottom className={classes.actiontypo}>
                    Delete
                  </Typography>
                </section>
              </MenuItem>
            </Menu>
          </div>
        );
      }
    }
  ];

  return (
    <>
      <Grid container className={classes.root}>
      <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" onClick={handleCopy}>
            COPY
          </Button>
        </Grid>
        <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" onClick={handleDownloadExcel}>
            EXCEL
          </Button>
        </Grid>
        <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" onClick={handleDownloadCSV}>
            CSV
          </Button>
        </Grid>
        <Grid item xs={1} md={1} lg={1} xl={1} className={classes.funBtn}>
          <Button variant="contained" onClick={handleDownloadPDF}>
            PDF
          </Button>
        </Grid>
        <Grid item xs={2} md={2} lg={2} xl={2} className={classes.funBtn}>
        </Grid>        
        <Grid item xs={6} md={6} lg={6} xl={6} className={classes.addBtn}>
          <Button variant="contained" onClick={handleOpenAddemployeeModal}>
            Add Employee
          </Button>
        </Grid>
        <Grid item xs={12}>
          <section className={classes.dataGridTable}>
            <DataGrid
              getRowId={(row) => row?.row?._id}
              rows={dataRows}
              columns={columns}
              pageSize={pageSize}
              onPageSizeChange={(newPageSize) => {
                setPageSize(newPageSize);
                setPage(1);
              }}
              onPageChange={(newPage) => handlePageChange(newPage)}
              rowsPerPageOptions={[5, 10, 25, 50]}
              pagination
              autoHeight={true}
              disableSelectionOnClick
              scrollbarSize={4}
              rowHeight={70}
              style={{ padding: "10px", borderRadius: "0px" }}
              paginationMode="server"
              rowCount={totalPages}
              filterMode="server"
              onFilterModelChange={(model) => {
                const value = model?.quickFilterValues?.[0] || "";
                //  console.log(value);
                  setSearchText(value);          
              }}
              components={{
            Toolbar: () => (
            <Box sx={{ p: 1, pb: 0, display: "flex", justifyContent: "flex-start" }}>
            <GridToolbarQuickFilter debounceMs={800} autoFocus/>
            </Box>
          ),
}}
            />
          </section>
        </Grid>
      </Grid>
      <CorporateAddemployeeModal
        openDialog={addemployeeModal}
        handleClose={handleCloseAddemployeeModal}
      ></CorporateAddemployeeModal>
      <CorporateUpdateModal
        openDialog={updateEmpModel}
        id={customerId}
        handleClose={handleCloseUpdateEmpModal}
      ></CorporateUpdateModal>
      <CorpempDeleteDialog
      openDialog={deleteEmpModal}
      id={customerId}
      handleClose={handleCloseDeleteEmpModal}
      empname={emp_name}
    ></CorpempDeleteDialog>
    </>
  );
};

export default Corporategroup;
